import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/pied-piper-pp': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M205.3 174.6C205.3 195.7 191.1 212.7 173.6 212.7 166.5 212.7 160.8 211.5 156.4 209V141C160.8 138.3 166.5 136.8 173.6 136.8 191.1 136.8 205.3 153.7 205.3 174.6zM257.9 241.6C250.8 241.6 245.1 243.1 240.7 245.8V313.8C245.1 316.3 250.8 317.5 257.9 317.5 275.3 317.5 289.6 300.6 289.6 279.7 289.6 258.6 275.3 241.6 257.9 241.6zM448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM185 255.1C226 255.1 259.2 219.5 259.2 175.5 259.2 131.5 226 95.9 185 95.9 173 95.9 160.9 99.1 150.4 104.7H104.7V311L156.5 300.9V250.3C165.1 253.4 174.6 255.1 185 255.1zM343.4 280.4C343.4 236.4 310.2 200.8 269.5 200.8 266.3 200.8 263.1 201 259.9 201.5 256.2 214 249.8 225.3 240.7 234.9 226.9 249.9 208.5 258.7 188.9 259.7V416L240.7 405.9V355.3C249.3 358.5 258.9 360 269.4 360 310.2 360 343.4 324.4 343.4 280.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/pied-piper-pp.js
// module id = l9+a
// module chunks = 144